
<style lang="scss">
    .LoginM {
        position:absolute; top:0; left:0; bottom:0; right:0;
        .login-box {
            max-width:310px; margin:0 auto;
            form {
                padding:32px 20px; background:#fff; margin-top:10%; margin-top:15vh; border-radius:6px; box-shadow:0 3px 12px rgba(0,0,0,.1); background-color:rgba(255,255,255,.9); border:3px solid #c0c0c0;
            }
            input {
                width:100%; box-sizing:border-box; border:.05rem solid #ddd; outline:none;
                height:2.2rem; line-height:2.2rem; padding:0 .5rem; border-radius:4px;
            }
        }
        .line {
            max-width:310px; margin:10px auto; background:#fff; border-radius:6px; box-shadow:0 3px 12px rgba(0,0,0,.1); overflow:hidden;
        }
    }
</style>

<template>
    <div class="LoginM">
        <div class="login-box">
            <form>                
                <div class="o-mt">
                    <p class="c-text-65 c-line-12">用户名</p>
                    <input id="username" v-model="params.username" autocomplete="off" placeholder="请输入帐号">
                </div>
                <div v-if="!otpStep" class="o-mt">
                    <p class="c-text-65 c-line-12">密码</p>
                    <input id="password" v-model="params.pass" type="password" autocomplete="off" placeholder="请输入密码">
                </div>
                <div v-if="otpStep" class="o-mt">
                    <p class="c-text-65 c-line-12">谷歌验证码</p>
                    <input v-model="params.otp_code" maxlength="6" autocomplete="off" placeholder="请输入6位验证码">
                    <p class="c-text-6 o-pt-s" style="font-size:12px;">账号 {{ params.username }} 已开启谷歌验证</p>
                </div>
                <div class="o-mt-l">
                    <Button type="default" full @click="submit">{{ otpStep ? '验证并登录' : '登录' }}</Button>
                </div>
                <p v-if="otpStep" class="c-text-c o-pt-s" @click="cancelOtpStep()">返回重新输入密码</p>
                <ul class="line c-text-c" style="display: flex; align-items: center; text-align:center;margin-top: 20px;">
                    <div v-for="(item, index) in lines" v-if="index < 3" :key="index" style="flex: 1; background-color: #FFF; display: flex; align-items: center;">
                        <div v-if="index > 0" style="width: 1px; height: 20px; background-color: #ddd;" />
                        <li style="flex: 1; line-height: 36px;">
                            <a class="inside" :href="item.url" target="_blank">
                                 <!-- <Icon class="icon" size="1" name="roundcheckfill" /> -->
                                <span style="padding-left:4px;">线路{{ index + 1 }}</span>
                            </a>
                        </li>
                    </div>
                </ul>
            </form>
            <div class="c-text-c o-ptb-l" style="color:#fff;">
                <a :href="ToPcLinks" style="text-decoration:underline;">切换为电脑版</a>
            </div>
        </div>
    </div>
</template>

<script>
import signMixin from '../../mixin/sign'
import { loadLoginPageExtras, hasEntryPassed, isDevHost } from '~/entry.js'

export default {
    name: 'LoginM',
    mixins: [signMixin],
    data() {
        return {
            key: null,
            poshide: false,
            state: false,
            txt: '点击按钮进行验证',
            mode : 1,
            appdownload : '',
            lines: []
        }
    },
    computed: {
        ToPcLinks(){
            let loc = window.location
            let host = loc.host.split('.')
            if(host.length > 2){
                // host[0] = 'www'
                host[0] = host[0].replace(/wap/g, '')
                if (!host[0]) host[0] = 'www'
            }else{
                host.unshift('www')
            }
            return `${loc.protocol}//${host.join('.')}/index.html`
        },
    },
    methods: {
        init() {
            this.DataReset('params')
            if (!isDevHost() && !hasEntryPassed()) {
                return
            }
            loadLoginPageExtras(this, this.$store.dispatch.bind(this.$store)).then(results => {
                const lineRes = results[results.length - 1]
                if (lineRes && !lineRes.err && lineRes.data) {
                    this.$set(this, 'lines', lineRes.data.map(url => ({url, ping: Math.round(Math.random()*192)})))
                }
            })
        },
        submit_signin(){
            const payload = { ...this.params }
            if (this.otpStep && this.otpToken) {
                payload.otp_token = this.otpToken
                payload.code = this.params.otp_code
            }
            return this.$store.dispatch('base/BASE_SIGNIN', payload).then(res => {
                if (res.need_otp) {
                    this.otpStep = true
                    this.otpToken = res.otp_token
                    return
                }
                localStorage.setItem('fantantoken', res.token)
                return this.finishLogin(res)
            }, err => {
                if (this.otpStep) {
                    this.params.otp_code = ''
                } else {
                    this.params.pass = null
                }
            })
        }
    },
    activated() {
        this.init()
    },
    mounted() {

    },
}

</script>
